(function() {
	'use strict';

	angular
		.module('components')
		.controller('CartFeeNoticeComponentController', CartFeeNoticeComponentController);

	/**
	 * The Cart Fee Notice Component Controller
	 * @constructor
	 * @param {Scope} $scope - The $scope
	 * @param {Service} ClientInfo - The ClientInfo Service
	 * @param {Service} Enums - The Enums Service
	 * @param {Service} FeeService - The FeeService Service
	 * @param {Service} Language - The Language Service
	 * @param {Enum} LanguageEnums - The Language Enums
	 * @returns {undefined}
	 * @ngInject
	 */
	function CartFeeNoticeComponentController($scope, ClientInfo, Enums, FeeService, Language, LanguageEnums) {
		var vm = this;

		var LOCALE_SECTION = 'Notice',
			M_ID = LanguageEnums.MERCHANT_ID;

		var getLocale = Language.getLocaleWithSuffixAndFallback,
			merge = Object.assign || angular.merge;

		merge(vm, {
			$onInit: _onInit,
			_: {
				adjustment: null,
				isMobile: ClientInfo.deviceType === Enums.deviceType.MOBILE
			}
		});

		/**
		 * Initializes the component
		 * @lifecycle
		 * @returns {undefined}
		 */
		function _onInit() {
			// Assign values to $scope
			merge($scope, {
				displayText: getLocale(LOCALE_SECTION, 'FeeNotice' + (vm.useDynamicDisplayText ? 'Dynamic' : ''), M_ID),
				onClick: onClick,
				popoverAlign: vm.popoverAlign || 'auto ' + (vm._.isMobile ? 'top' : 'top-right'),
				popoverText: getLocale(LOCALE_SECTION, 'FeeNoticeHover', M_ID),
				showPopover: !vm.hidePopover,
				smallText: vm.smallText
			});

			// Pull the adjustment from the FeeService
			vm._.adjustment = FeeService.getAdjustmentFromPackageId(vm.packageId, vm.pageKey);

			// If we have an adjustment for the package
			if (vm._.adjustment) {
				// if the popover text locale has a value
				if ($scope.popoverText) {
					// replace the placeholders
					$scope.popoverText = FeeService.swapLocaleVariables(vm.pageKey, $scope.popoverText, vm._.adjustment.displayAmount, vm._.adjustment.name);
				}
			} else {
				// There is no matching adjustment, use the default hover and replace the placeholders
				$scope.popoverText = FeeService.swapLocaleVariables(vm.pageKey, getLocale(LOCALE_SECTION, 'FeeNoticeHoverDefault', M_ID));
			}
		}

		/**
		 * Makes sure clicking the info button does not leak down to parent divs
		 * @returns {undefined}
		 */
		function onClick($event) {
			$event.stopPropagation();
		}
	}
})();